// ─── Ajustes internos del formato impreso ────────────────────────────────────
// Preferencias de cómo se ve un documento al imprimirlo, editables desde
// Configuración → Formato de documentos. Viven en erp:formato_documentos y se
// sincronizan a la nube como cualquier otra configuración (CONFIG_CLOUD_KEYS),
// así que el ajuste vale para toda la empresa y no para un solo navegador.

export const FORMATO_DOC_KEY = "erp:formato_documentos";

export const FORMATO_DOC_DEFAULTS = {
  // Lado de la miniatura del producto en la tabla de ítems de la cotización.
  // 110px ≈ 2,9 cm impresos: se ve el producto sin desplazar a la descripción.
  imagenCT: 110
};

export const IMAGEN_CT_MIN = 60;
export const IMAGEN_CT_MAX = 220;

// Caché en memoria: el formato se arma fila por fila y no conviene reparsear
// JSON en cada ítem. saveFormatoDoc y refrescarFormatoDoc la invalidan.
let _cfg = null;

export function getFormatoDoc() {
  if (_cfg) return _cfg;
  let guardado = {};
  try {
    const raw = localStorage.getItem(FORMATO_DOC_KEY);
    if (raw) guardado = JSON.parse(raw) || {};
  } catch { guardado = {}; }
  _cfg = { ...FORMATO_DOC_DEFAULTS, ...guardado };
  // Un valor fuera de rango (config vieja, edición a mano) no debe romper la
  // maquetación: se recorta en vez de confiar en él.
  _cfg.imagenCT = Math.min(IMAGEN_CT_MAX, Math.max(IMAGEN_CT_MIN, Number(_cfg.imagenCT) || FORMATO_DOC_DEFAULTS.imagenCT));
  return _cfg;
}

export function saveFormatoDoc(cfg) {
  _cfg = { ...FORMATO_DOC_DEFAULTS, ...cfg };
  _cfg.imagenCT = Math.min(IMAGEN_CT_MAX, Math.max(IMAGEN_CT_MIN, Number(_cfg.imagenCT) || FORMATO_DOC_DEFAULTS.imagenCT));
  try { localStorage.setItem(FORMATO_DOC_KEY, JSON.stringify(_cfg)); } catch {}
  return _cfg;
}

// La configuración pudo cambiar en otra sesión (Realtime) o al recargar caché.
export function refrescarFormatoDoc() { _cfg = null; }
